import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import BackButton from "../components/BackButton";
import Button from "../components/Button";
import { Modal } from "react-bootstrap";
import "./ConfirmWarehouse.css";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import api from "../api/api";

const ConfirmWarehouse = () => {
  const navigate = useNavigate();
  const { id, warehouseId, ownerId } = useParams();
  const [requestDetails, setRequestDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    const fetchRequestDetails = async () => {
      try {
        const response = await api.get(`/wh-owner/request-details/${id}`);
        const { request } = response.data;
        setRequestDetails(request);
      } catch (err) {
        console.error("Error fetching request details:", err);
        setError("Failed to load request details.");
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchRequestDetails();
    }
  }, [id]);

  const handleConfirmBooking = () => {
    setShowConfirm(true);
  };

  const handleConfirm = async () => {
    setShowConfirm(false);
    try {
      const response = await api.post('/warehouse/book-warehouse', {
        warehouse_request_id: parseInt(id),
        selected_owner_id: ownerId,
        warehouse_id: warehouseId,
      });
      setShowSuccess(true);
    } catch (err) {
      console.error("Error booking warehouse:", err);
      alert("Failed to book warehouse. Please try again.");
    }
  };

  const handleSuccessClose = () => {
    setShowSuccess(false);
    navigate(`/warehouse-request-responses/${id}`);
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!requestDetails) return <div>No data found.</div>;

  return (
    <>
      <BackButton />
      <div className="row">
        <div className="col-sm-6 d-flex">
          <div className="confirmwarehousecard w-100 bg-white mb-3 mb-md-4">
            <h4>Warehouse Details</h4>
            <p>
              <span>Location: </span>{requestDetails.pincode || 'N/A'}
            </p>
            <p>
              <span>Rates: </span>{requestDetails.volumetric_weight || 'N/A'}
            </p>
            <p>
              <span>Availability Status: </span>Available
            </p>
          </div>
        </div>
        <div className="col-sm-6 d-flex">
          <div className="confirmwarehousecard w-100 bg-white mb-3 mb-md-4">
            <h4>Booking Summary</h4>
            <p>
              <span>Product Name: </span>{requestDetails.product_name || 'N/A'}
            </p>
            <p>
              <span>Storage Type: </span>{requestDetails.storage_type || 'N/A'}
            </p>
            <p>
              <span>Start Date: </span>{requestDetails.start_date || 'N/A'}
            </p>
            <p>
              <span>End Date: </span>{requestDetails.end_date || 'N/A'}
            </p>
          </div>
        </div>
      </div>
      <div className="warningdiv mb-4">
        <WarningAmberIcon className="me-2" />
        Once Confirmed, This Warehouse Will be booked for you and other offers
        will be hidden
      </div>
      <div className="d-flex justify-content-end">
        <Button text="Confirm Booking" variant="primary" onClick={handleConfirmBooking} />
      </div>

      {/* Confirm Modal */}
      <Modal show={showConfirm} onHide={() => setShowConfirm(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Booking</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to book this warehouse?</Modal.Body>
        <Modal.Footer>
          <Button
            text="Cancel"
            variant="secondary"
            onClick={() => setShowConfirm(false)}
          />
          <Button text="Confirm" variant="primary" onClick={handleConfirm} />
        </Modal.Footer>
      </Modal>

      {/* Success Modal */}
      <Modal show={showSuccess} onHide={handleSuccessClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Success</Modal.Title>
        </Modal.Header>
        <Modal.Body>Warehouse booked successfully!</Modal.Body>
        <Modal.Footer>
          <Button text="OK" variant="success" onClick={handleSuccessClose} />
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConfirmWarehouse;
